var render = function render(){var _vm=this,_c=_vm._self._c;return _c('k-dialog',[_c('div',{staticClass:"dialog-effect-wrapper"},[_c('img',{staticClass:"bg",attrs:{"src":_vm.img.aniImg || _vm.defaultImg}}),_c('img',{staticClass:"btn y-rotate",style:(_vm.aStyle),attrs:{"src":_vm.img.aniBtn || _vm.defaultBtn}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }